export const categoriesList = state => state.categoriesList;
export const relatedPosts = state => state.relatedPosts;
export const userInfo = state => state.userInfo;
export const userName = state => state.userInfo.name;
export const progress = state => state.userInfo.progress;
export const currentPost = state => state.currentPost;
export const introduction = state => state.introduction;
export const openCategories = state => state.openCategories;
export const group = state => state.group;



// WEBPACK FOOTER //
// ./src/screens/Index/store/getters.js